// extracted by mini-css-extract-plugin
module.exports = {"evento":"Evento_evento__3LdjS","opcoes":"Evento_opcoes__1uy_7"};